import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-cms-login',
    templateUrl: './cms-login.component.html',
    styleUrls: ['./cms-login.component.scss']
})
export class CmsLoginComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.authService.isAdmin$.subscribe(val => {
            if(val == true) {
                this.router.navigateByUrl('/cms')
            }
        })
    }

    login() {
        this.authService.login()
    }

}
